import { http } from '@/utils/httpClient'

export interface AppConfigDoc {
  id: string
  settings: Record<string, any>
  updated_by?: string
  updated_by_name?: string
  updated_at?: string
}

export const CONFIG_IDS = {
  ACCESSIBILITY_TEST_NAME_PROJECT_MAP: 'accessibility-map',
} as const

export class ConfigService {
  private readonly baseUrl = '/config'

  async get(id: string): Promise<AppConfigDoc | null> {
    try {
      return await http.get(`${this.baseUrl}?id=${encodeURIComponent(id)}`)
    } catch (err: any) {
      // 404 just means the config has never been written — surface as null so
      // callers can treat it as an empty map without try/catching themselves.
      if (err?.response?.status === 404 || err?.status === 404) return null
      throw err
    }
  }

  async patch(id: string, settings: Record<string, any>): Promise<AppConfigDoc> {
    return await http.patch(`${this.baseUrl}`, { id, settings })
  }
}

export const configService = new ConfigService()
